import pt from '@/modules/localization/locales/pt';
import en from '@/modules/localization/locales/en';
import es from '@/modules/localization/locales/es';
import { createI18n } from 'vue-i18n';
export const i18n = createI18n({
  locale: localStorage.getItem('locale') ||
    navigator.language.split('-')[0] || navigator.userLanguage.split('-')[0] || process.env.VUE_APP_DEFAULT_LOCALE,
  fallbackLocale: process.env.VUE_APP_FALLBACK_LOCALE,
  legacy: false,
  globalInjection: true,
  messages: { pt, en, es },
  runtimeOnly: false,
});
